/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type FlexPaymentMethodQueryVariables = Types.Exact<{ [key: string]: never }>;

export type FlexPaymentMethodQuery = {
  readonly __typename?: 'Query';
  readonly flexCustomerData:
    | {
        readonly __typename: 'FlexCustomerData';
        readonly flexPaymentMethods: ReadonlyArray<{
          readonly __typename: 'FlexPaymentMethod';
          readonly brand: string | null;
          readonly expMonth: number | null;
          readonly expYear: number | null;
          readonly last4: string | null;
        }>;
      }
    | { readonly __typename: 'UnableToGetFlexCustomerDataError'; readonly errorMessage: string }
    | null;
};

export const FlexPaymentMethodDocument = gql`
  query FlexPaymentMethod {
    flexCustomerData {
      ... on FlexCustomerData {
        __typename
        flexPaymentMethods {
          __typename
          brand
          expMonth
          expYear
          last4
        }
      }
      ... on UnableToGetFlexCustomerDataError {
        __typename
        errorMessage
      }
    }
  }
`;

export function useFlexPaymentMethodQuery(
  options?: Omit<Urql.UseQueryArgs<FlexPaymentMethodQueryVariables>, 'query'>,
) {
  return Urql.useQuery<FlexPaymentMethodQuery, FlexPaymentMethodQueryVariables>({
    query: FlexPaymentMethodDocument,
    ...options,
  });
}
